export const postDonationGuideTour = {
  tourKey: 'post_donation_guide',
  conditions: {
    orgTypes: ['business'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      title: 'tours.post-donation-guide.welcome.title',
      content: 'tours.post-donation-guide.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="open-donation-eye"]',
      title: 'tours.post-donation-guide.open-details.title',
      content: 'tours.post-donation-guide.open-details.content',
      placement: 'bottom',
    },
  ],
};
